<template>
  <div>
    <div v-for="(f, index) in filteredFields" :key="index" class="block-infofield clearfix">
      <!-- #D59 -->
      <div class="pull-left offset-bottom-1 offset-right-1">
        <span v-if="f.resourcePath" class="infofield-img">
          <img :src="`delegates/product/content/${f.resourcePath}`" alt="" class="offset-right-1" />
        </span>
        <!-- #D60 -->
        <span class="detail text block" v-html="f.descriptionText"></span>&nbsp;
      </div>
      <!-- #D61 -->
      <span v-if="f.url">
        <a
          :href="f.url"
          class="btn btn-white btn-small pull-right offset-bottom-1 infofield-link"
          role="button"
          target="_blank"
          tabindex="0"
          :aria-label="computedAriaLabel(f)"
        >
          {{ f.text }}
          <scale-icon-navigation-external-link v-if="f.externalLink" size="16" />
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformationField',

  props: {
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },

    important: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    filteredFields() {
      return this.fields.filter((i) => !!i.isImportant === this.important);
    },
  },

  methods: {
    computedAriaLabel(field) {
      return field.externalLink ? field.ariaLabelText || this.$t('substore.aria_label_text_external_link') : null;
    },
  },
};
</script>

<style scoped>
.infofield-link {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
</style>
